module.exports = __webpack_public_path__ + "static/media/jdip.f70f23b3.jpg";